<template>
  <button
    type="button"
    class="dark-switch-btn w-11 h-11 flex items-center justify-center rounded-xl text-gray-600 hover:text-gray-700 dark:text-white dark:hover:text-white hover:bg-gray-50 dark:hover:bg-white/10 transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105 bg-white dark:bg-gradient-to-br dark:from-[#007aff] dark:to-[#5856d6] border border-black/10 dark:border-white/20"
    @click="toggleTheme"
  >
    <i class="material-symbols-outlined text-lg">
      {{ icon }}
    </i>
  </button>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

export default defineComponent({
  name: "DarkSwtichBtn",
  setup() {
    const icon = ref("light_mode");

    const toggleTheme = () => {
      const body = document.body;
      const darkThemeClass = "dark";

      if (body.classList.contains(darkThemeClass)) {
        body.classList.remove(darkThemeClass);
        icon.value = "light_mode";
        localStorage.setItem("theme", "light");
      } else {
        body.classList.add(darkThemeClass);
        icon.value = "dark_mode";
        localStorage.setItem("theme", "dark");
      }
    };

    onMounted(() => {
      const savedTheme = localStorage.getItem("theme");
      if (savedTheme === "dark") {
        document.body.classList.add("dark");
        icon.value = "dark_mode";
      }
    });

    return {
      icon,
      toggleTheme,
    };
  },
});
</script>
